<template>
  <Simple />
</template>

<script>
import Simple from '../../components/categories/index.vue'
export default {
  components: {
    Simple,
  },
}
</script>
